import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const CTA = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  return (
    <section ref={ref} className="bg-white py-20 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="bg-purple-50 rounded-2xl p-8 sm:p-12 text-center shadow-lg"
        >
          <motion.h2 variants={itemVariants} className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Ready to Join the Founding Community?
          </motion.h2>
          <motion.p variants={itemVariants} className="mt-4 text-lg leading-8 text-gray-600 max-w-2xl mx-auto">
            Be part of our journey from the very beginning. As a founding member, you'll get exclusive access, early updates, and a chance to shape the future of Togethr.
          </motion.p>
          <motion.div variants={itemVariants} className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="https://wa.me/message/ST34ZBAH3RQDH1"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-md bg-purple-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-purple-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600 transition-colors"
            >
              Get Early Access Now
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;